export enum GeneralProcessType {
    TASK = 1,
    JOB
}
